/* eslint-disable no-dupe-keys */
import colors from "assets/theme/base/colors";
import { formatMoneyPunto } from "utils/formatters";

const { gradients, dark } = colors;

function configs(labels, datasets) {
  return {
    data: {
      labels,
      datasets: [
        {
          label: datasets.label,
          weight: 9,
          cutout: 0,
          borderWidth: 2,
          backgroundColor: datasets.backgroundColors,
          data: datasets.data,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      layout: {
        padding: 10,
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
          callbacks: {
            label: (context) => {
              const label = context.label || "";
              const value = context.parsed || 0;
              const total = context.dataset.data.reduce((a, b) => a + b, 0);
              const porcentaje = total > 0 ? ((value * 100) / total).toFixed(2) : 0;
              return `${label}: ${formatMoneyPunto(value)} (${porcentaje}%)`;
            },
          },    
        },
      },
      interaction: {
        intersect: true,
        mode: "nearest",
      },
    },
  };
}

export default configs;